import handler from 'api/handler'

const prefix = '/public/qualification'

const methods = {
  getQualifications: args => handler({ method: 'get', url: `${prefix}/qualifications`, args })
}

export default methods


